export const isClient = typeof window !== "undefined"
export const isServer = typeof global !== "undefined" && !isClient
